var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "container", attrs: { type: "flex" } },
        [
          _c("el-col", [
            _c("h2", { staticClass: "titulo" }, [
              _vm._v("Arrecadação de terras")
            ])
          ]),
          _c("el-col", [
            _c(
              "div",
              { staticClass: "button" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", icon: "el-icon-plus" },
                    on: { click: _vm.criarCadastroColetivo }
                  },
                  [
                    _c("span", { staticClass: "center" }, [
                      _vm._v("Criar processo")
                    ])
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c("pesquisa", {
                attrs: {
                  placeHolder: "Informe o nome da Gleba ou nº do Processo",
                  cardStyle: {
                    margin: "0px 0px 10px 0px",
                    "border-radius": "12px"
                  }
                },
                on: {
                  search: _vm.handlePesquisa,
                  resetSearch: _vm.resetPesquisa
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("app-divider-refresh-button", {
            attrs: {
              label: "Listagem de cadastros",
              hasButton: true,
              content: "Atualizar retificações"
            },
            on: { click: _vm.getProcessosArrecadacao }
          }),
          _c("table-generica", {
            attrs: {
              colunas: _vm.colunas,
              botoesAcao: _vm.botoesAcao,
              sortChanged: _vm.sortChanged,
              dados: _vm.processosArrecadacao
            }
          }),
          _c("app-paginacao", {
            attrs: { total: _vm.totalCadastros, pagina: _vm.pagina },
            on: { changePage: _vm.changePage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56177bf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56177bf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gat/Home.vue
// module id = null
// module chunks = 